export const productNameWithCountry = (
  productName: string,
  productCountryOfOriginName: string | null,
) => {
  return `${productName} ${productCountryOfOriginName ? ` (${productCountryOfOriginName})` : ""}`;
};
